import { Pipe, PipeTransform } from '@angular/core';
import { TransportMode } from '../../../models/shipment';
import { Shipment } from '../../../pages/overview/models/shipment';

@Pipe({
  name: 'shouldShowContainers',
  standalone: true
})
export class ShouldShowContainersPipe implements PipeTransform {
  transform(shipment: Shipment | null): boolean {
    if (!shipment) {
      return false;
    }
    const transportMode = shipment.transportMode;
    const allowedTransportModes: TransportMode[] = ['Ocean', 'Rail'];
    return (
      !!transportMode &&
      allowedTransportModes.includes(transportMode) &&
      shipment.containers &&
      shipment.containers.length > 0 &&
      shipment.containers.some(container => container.containerNo || container.containerType)
    );
  }
}
